import React from "react";
import { makeStyles } from '@mui/styles';
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
const useStyles = makeStyles(theme => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    }
  },
  paper: {
    backgroundColor: "#ffffff",
    padding: theme.spacing(2, 4, 3),
    borderRadius: "15px",
    width: "380px",
    position: 'relative',
    outline: 'none',
    boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)'
  }
}));

export default function TransitionsModal(props) {
  const classes = useStyles();
  const {showTimeOutModel, _onSubmit, _setFinishModal, _setTimeoutModelShow,result, showResult, showscore,updateFlag, examDetail,
    // examId, setWindowSwitch, setTestData, windowSwitchCount, testData
  } = props;

  // onWindowReload(examId,examDetail,setWindowSwitch,setTestData,windowSwitchCount,testData)

  const handleClose = () => {
    // onSubmit('011');
    // window.onbeforeunload = (event) =>{
    //   event.preventDefault();
    // }

    window.onbeforeunload = function () {
      return null;  // return null to avoid pop up
    }

    window.location.reload('/dashboard')
    // setTimeoutModelShow(false)
    // setFinishModal(true)
  };

  return (
    <div>

      <Modal
        disableEnforceFocus = {true}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={showTimeOutModel}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={showTimeOutModel}>
        <div className={classes.paper} style={{textAlign:"justify"}}>

          <div style={{textAlign:"center"}}>

<h3 id="transition-modal-title" style={{color:'#6f2981',marginBottom:"30px"}}>System Warning</h3>
</div>
            <p id="transition-modal-description">
            Your {examDetail[0].test_type === "7" || examDetail[0].test_type === "8" ? "Survey" : "Test"} has been auto-submitted.
            <br/>
            <br/>
            Thanking you,
            <br/>
            Support, AssessHub.
            </p>
            {(showscore || !updateFlag) ? (result !== undefined && result !== null && showResult
            ? <div className="form-group" style={{textAlign:"center"}}>
                <p style={{fontWeight:'bold'}} dangerouslySetInnerHTML={{__html: result}}></p>
					      <ul className="list-inline">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <li><a href="#" className="btn btn-blue"  style={{borderRadius:"10px"}} onClick={() => handleClose()} ><strong>Close</strong></a></li>
                </ul>
                </div> :
                 <p>
                 Your result is being processed. Please <span style={{ color: 'red' }}><strong>DO NOT </strong></span>refresh this page or close the browser, else your test result will be considered <span style={{ color: 'red' }}><strong>INVALID.</strong></span>
                </p>):
                  <div className="form-group" style={{textAlign:"center"}}>
					      <ul className="list-inline">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <li><a href="#" className="btn btn-blue"  style={{borderRadius:"10px"}} onClick={() => handleClose()} ><strong>Close</strong></a></li>
                </ul>
                </div>}
            {/* <div className="form-group" style={{textAlign:"center"}}>
					      	<ul className="list-inline btn-list">
                <li><a className="btn btn-blue" style={{borderRadius:"10px"}} onClick={() => handleClose()} >
                <strong>Close</strong>
            </a>
                </li>

                </ul>
                </div> */}

          </div>
        </Fade>
      </Modal>
    </div>
  );
}
